import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import masterService from '../../../services/masterService';

export const PackagePanelMappingSection = ({ packageData, onClose }) => {
  const navigate = useNavigate();
  const [panels, setPanels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');

  useEffect(() => {
    let isMounted = true;
    const fetchPanels = async () => {
      setLoading(true);
      try {
        const res = await masterService.getPanels({ isActive: true });
        if (isMounted && res && res.success) {
          setPanels(res.data || []);
        }
      } catch (err) {
        console.error('Error fetching panels:', err);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchPanels();
    return () => {
      isMounted = false;
    };
  }, []);

  const filteredPanels = panels.filter(p => {
    if (!search.trim()) return true;
    const q = search.toLowerCase();
    return p.panelName?.toLowerCase().includes(q) || p.panelCode?.toLowerCase().includes(q);
  });

  return (
    <div className="pkg-modal-backdrop" onClick={onClose} role="dialog" aria-modal="true">
      <div className="pkg-panel-modal fade-in" onClick={(e) => e.stopPropagation()}>
        <div className="pkg-modal-header">
          <div>
            <div className="pkg-card-top-row">
              <span className="pkg-badge-panel">STAGE 2: COMMERCIAL PANEL MAPPING</span>
            </div>
            <h3 className="pkg-modal-title">Panel Mapping & Tariff Setup</h3>
            <span className="pkg-modal-subtitle">
              Package: <strong>{packageData?.packageName}</strong> ({packageData?.packageCode})
            </span>
          </div>
          <button type="button" className="pkg-modal-close" onClick={onClose} aria-label="Close modal">
            ✕
          </button>
        </div>

        <div className="pkg-modal-body">
          {/* Architecture Explanation */}
          <div className="pkg-mapping-info-card">
            <div className="pkg-mapping-info-icon">💡</div>
            <div className="pkg-mapping-info-text">
              <strong>Tariff Separation Architecture:</strong>
              <p>
                Clinical packages define the tests included for a patient. Commercial pricing (cash rates, corporate agreements, TPA tariffs) is configured panel-by-panel in the Panel Tariff Master.
              </p>
            </div>
          </div>

          {/* Search Panels */}
          <div className="pkg-search-bar" style={{ marginBottom: '1rem' }}>
            <span className="pkg-search-lens">🔍</span>
            <input
              type="text"
              className="pkg-search-field"
              placeholder="Search panels by name or code..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>

          {/* Panels List */}
          {loading ? (
            <div className="pkg-loading-state">
              <div className="pkg-spinner"></div>
              <span>Loading commercial panels...</span>
            </div>
          ) : filteredPanels.length === 0 ? (
            <div className="pkg-empty-state">
              <span>No panels found matching your search.</span>
            </div>
          ) : (
            <div className="pkg-panels-grid">
              {filteredPanels.map((p) => (
                <div key={p.panelId} className="pkg-panel-item-card">
                  <div className="pkg-panel-item-header">
                    <span className="pkg-panel-type-tag">
                      {p.panelType || (p.isDefaultCash ? 'Cash Default' : 'Corporate / TPA')}
                    </span>
                    <span className="pkg-panel-status-tag active">● Active</span>
                  </div>
                  <h5 className="pkg-panel-name">{p.panelName}</h5>
                  <span className="pkg-panel-code">Code: {p.panelCode || '—'}</span>

                  <div className="pkg-panel-action-row">
                    <button
                      type="button"
                      className="btn btn-secondary btn-sm"
                      onClick={() => {
                        onClose();
                        navigate(`/masters/panel-rates?panelId=${p.panelId}`);
                      }}
                      title="Configure tariffs for this panel"
                    >
                      Configure Panel Tariffs ➔
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="pkg-modal-footer">
          {packageData?.itemId && (
            <button
              type="button"
              className="btn btn-primary"
              style={{ backgroundColor: '#059669', borderColor: '#059669' }}
              onClick={() => {
                onClose();
                navigate(`/masters/item-rates?itemType=PACKAGE&itemId=${packageData.itemId}`);
              }}
            >
              📦 Configure Package Tariff Across All Panels ➔
            </button>
          )}
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => {
              onClose();
              navigate('/masters/panel-rates');
            }}
          >
            Open Panel Tariffs
          </button>
          <button type="button" className="btn btn-secondary" onClick={onClose}>
            Done
          </button>
        </div>
      </div>
    </div>
  );
};

export default PackagePanelMappingSection;
